"use strict";

const onResizeCallbacks = [];

$(() => {
  let timer;
  let wait = false;

  $(window).resize(function () {
    if (wait) {
      return;
    }
    wait = true;

    timer = window.setTimeout(function () {
      window.clearTimeout(timer);
      onResizeCallbacks.forEach((callback, i) => {
        callback();
      });
      wait = false;
    }, 200);
  });

  const cards = $(".luftwaffe-cards .luftwaffe-card-bg");
  const cardsHeightCallback = () => {
    let maxHeight = 0
    cards.each((i, card) => {
      card.style.height = "";
      maxHeight = Math.max(maxHeight, card.offsetHeight);
    });
    cards.each((i, card) => {
      card.style.height = maxHeight + "px";
    });
  }

  cardsHeightCallback();
  onResizeCallbacks.push(cardsHeightCallback);
});
